import {
    format, getDateFormat, translateFormat,
    DATE_FORMAT, TIME_FORMAT, DATETIME_FORMAT, SHORT_DATE_FORMAT, SHORT_DATETIME_FORMAT,
} from '@/utils/date';
import {gettext, ngettext, pgettext, npgettext, interpolate} from "@/utils/translate";
import {reverseUrl, staticUrl} from "@/url";
import {currentUser} from "@/infrastructure/user";

const FMT_DATE = getDateFormat(DATE_FORMAT);
const FMT_DATETIME = getDateFormat(DATETIME_FORMAT);
const FMT_TIME = getDateFormat(TIME_FORMAT);
const FMT_SHORT_DATE = getDateFormat(SHORT_DATE_FORMAT);
const FMT_SHORT_DATETIME = getDateFormat(SHORT_DATETIME_FORMAT);
const FMT_DATE_WITHOUT_YEAR = translateFormat('j. n.');


export const filters = {
    gettext(message) {
        return gettext(message);
    },

    ngettext(message, messagePlural, count) {
        return ngettext(message, messagePlural, count);
    },

    pgettext(context, message) {
        return pgettext(context, message);
    },

    npgettext(context, message, messagePlural, count) {
        return npgettext(context, message, messagePlural, count);
    },

    interpolate(format, params) {
        const named = !(params instanceof Array);
        return interpolate(format, params, named);
    },

    formatDate(value) {
        return format(value, FMT_DATE);
    },

    formatShortDate(value) {
        return format(value, FMT_SHORT_DATE);
    },

    formatTime(value) {
        return format(value, FMT_TIME);
    },

    formatDateTime(value) {
        return format(value, FMT_DATETIME);
    },

    formatShortDateTime(value) {
        return format(value, FMT_SHORT_DATETIME);
    },

    formatDateWithoutYear(value) {
        return format(value, FMT_DATE_WITHOUT_YEAR);
    },

    formatCurrency(value, currency = 'EUR', defaultValue = '') {
        if (value) {
            const floatValue = parseFloat(value);
            if (floatValue > 0) {
                return floatValue.toLocaleString(undefined, {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
            }
        }

        return defaultValue;
    },

    formatPcs(count) {
        if (!count) {
            count = 0;
        }

        return interpolate(
            ngettext(
                '%(count)s pc',
                '%(count)s pcs',
                count
            ),
            {
                'count': count.toLocaleString(),
            },
        )
    },

    reverseUrl(name, ...args) {
        return reverseUrl(name, ...args);
    },

    staticUrl(url) {
        return staticUrl(url);
    },

    userIsStaff() {
        return currentUser.isStaff;
    },

    formatInteger(value, defaultValue = 0) {
        if (value) {
            const intValue = parseInt(value, 10);
            if (intValue !== 0) {
                return intValue.toLocaleString();
            }
        }

        return defaultValue;
    },
}
